import LocalStorage from '@/utils/LocalStorage';

export class AppService {

  public showStickyArtzie: boolean = true;
  public drawer: boolean = false;
  public loginDialog: boolean = false;
  public loginTitle: string = '';
  public searchPanel: boolean = false;
  public pageDialog = {
    show: false,
    slug: null
  };
  public userCountry: string = "";
  public searchBtn: boolean = false; // Only to trigger search

  public vToast: any = {
    show: false,
    message: null,
    duration: 1500,
    color: "success"
  };

  public toast = (message: string, duration: number = 1500, color = "success") => {
    this.vToast.show = true;
    this.vToast.message = message;
    this.vToast.duration = duration;
    this.vToast.color = color;
  };

  public userWalls: any[] = [];

  public visitsCounter: number = 0;

  constructor() {
    this.visitsCounter = LocalStorage.visitsCounter;
    LocalStorage.incrementVisitsCounter();
  }

  // if the visit counter >= 3, the search pop is not shown
  public searchPopupClosed() {
    LocalStorage.incrementVisitsCounter(3);
  }

  setTitle(title: string) {
    document.title = `${title} | Taiko`;
  }

}
